import { scaleLinear } from 'd3-scale';
import { jsx } from 'react/jsx-runtime';
import { useLabels } from '../Labels/hooks/useLabels.js';
import { shouldSkipLabel } from '../Labels/utilities/shouldSkipLabel.js';
import { TextLine } from '../TextLine/TextLine.js';

function XAxis({
  allowLineWrap,
  ariaHidden = false,
  isLinearChart = false,
  labels,
  labelWidth,
  onHeightChange,
  reducedLabelIndexes,
  x,
  xScale,
  y
}) {
  const {
    lines
  } = useLabels({
    labels,
    onHeightChange,
    targetWidth: labelWidth,
    allowLineWrap
  });
  return /*#__PURE__*/jsx("g", {
    "aria-hidden": true,
    children: lines.map((line, index) => {
      // Skip last labels for linear charts so they
      // don't spill outside the chart area.
      const skipLastLabel = isLinearChart && labels.length > 1 && index === labels.length - 1;

      if (shouldSkipLabel(index, reducedLabelIndexes) || skipLastLabel) {
        return null;
      }

      const xPosition = getXPosition(index, xScale);
      return /*#__PURE__*/jsx("g", {
        transform: `translate(${x + (xPosition !== null && xPosition !== void 0 ? xPosition : 0)},${y})`,
        "aria-hidden": ariaHidden,
        children: /*#__PURE__*/jsx(TextLine, {
          line: line,
          index: index
        })
      }, index);
    })
  });
}

function getXPosition(index, xScale) {
  if (xScale instanceof scaleLinear) {
    return xScale(index);
  }

  return xScale(`${index}`);
}

export { XAxis };
